import IndexCard  from "./IndexCard";

export default IndexCard;